import React, { Fragment } from 'react';
import { Form } from '../../../ui/universe';
import { getSelectRectKey } from '../utils';

/**
 * KeyMap 渲染器 - 键值对映射渲染
 * @param {Object} props
 * @param {Object} props.params - OCR 响应参数
 * @param {Object} props.config - 结果配置
 * @param {Object} props.detail - 菜单详情配置
 * @param {string} props.selectRect - 当前选中的矩形 key
 * @param {Function} props.onSelect - 选中回调
 */
const KeyMapRenderer = ({ params, config, detail, selectRect, onSelect }) => {
  return (
    <>
      {params[config.firstField]?.map((i, index) => {
        const selectRectVal = getSelectRectKey({
          data: i,
          key: detail?.rectConfig?.RectKey,
          valStr: i[config.key2 || 'Value']
        });

        return (
          <Fragment key={`keymap-${index}`}>
            {config.secondField ? (
              <>
                {i[config.secondField]?.map((v, vIndex) => (
                  <Fragment key={`keymap-v-${vIndex}`}>
                    {!(config.hide && v[config.key1 || 'Name'].includes(config.hide)) && (
                      <Form.Item
                        className={`${selectRect === selectRectVal ? 'isSelect' : ''}`}
                        label={v[config.key1 || 'Name']}
                        onClick={() => {
                          onSelect && onSelect(v[config.key2 || 'Value'], selectRectVal);
                        }}
                      >
                        {v[config.key2 || 'Value']}
                      </Form.Item>
                    )}
                  </Fragment>
                ))}
              </>
            ) : (
              <>
                {!(config.hide && i[config.key1 || 'Name'].includes(config.hide)) && (
                  <Form.Item
                    className={`${selectRect && selectRect === selectRectVal ? 'isSelect' : ''}`}
                    label={i[config.key1 || 'Name']}
                    onClick={() => {
                      onSelect && onSelect(i[config.key2 || 'Value'], selectRectVal);
                    }}
                  >
                    {i[config.key2 || 'Value']}
                  </Form.Item>
                )}
              </>
            )}
          </Fragment>
        );
      })}
    </>
  );
};

export default KeyMapRenderer;
